function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import classnames from 'classnames';
import T from 'prop-types';
import React from 'react';
import Img from '../../components/img/Img';
import Icon from '../../components/icon/Icon';
var UserAvatar = function(props) {
    var profileImage = props.profileImage, className = props.className, _props_avatarIcon = props.avatarIcon, avatarIcon = _props_avatarIcon === void 0 ? 'v2' : _props_avatarIcon, hasBorder = props.hasBorder, borderStyle = props.borderStyle, crossOrigin = props.crossOrigin;
    // TODO: should remove avatarIcon props when Account page will be updated/refactored
    if (!profileImage && avatarIcon === 'v2') {
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames('UserAvatar d-flex flex-row justify-content-center align-items-center rounded-circle overflow-hidden pb-1', _define_property({}, className, className)),
            style: _object_spread({
                background: '#dcdcdc'
            }, hasBorder && {
                border: borderStyle ? borderStyle : '3px solid #3048c9'
            })
        }, /*#__PURE__*/ React.createElement(Icon, {
            icon: "avatar-no-profile"
        }));
    }
    var _obj;
    return /*#__PURE__*/ React.createElement(Img, _object_spread({
        className: classnames('UserAvatar', (_obj = {}, _define_property(_obj, className, className), _define_property(_obj, "bordered", hasBorder), _obj)),
        img: profileImage || '/public/img/user-silhouette.png',
        isUrl: true,
        roundedCircle: true
    }, crossOrigin && {
        crossOrigin: 'anonymous'
    }, hasBorder && borderStyle ? {
        style: {
            border: borderStyle
        }
    } : null));
};
UserAvatar.propTypes = {
    profileImage: T.string,
    className: T.string,
    hasBorder: T.bool,
    borderStyle: T.string,
    avatarIcon: T.string,
    crossOrigin: T.bool
};
export default UserAvatar;
